/* Luxaura Essentials — theme scripts (no dependencies) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const overlay = () => $('[data-overlay]');

  /* ---------- Drawers ---------- */
  const Drawer = {
    open(id) {
      const d = document.getElementById(id);
      if (!d) return;
      $$('.drawer.is-open').forEach((x) => x !== d && x.classList.remove('is-open'));
      d.classList.add('is-open');
      overlay()?.classList.add('is-active');
      document.body.classList.add('no-scroll');
      const focusable = d.querySelector('input:not([type=hidden]), button, a');
      setTimeout(() => focusable && focusable.focus({ preventScroll: true }), 250);
    },
    close() {
      $$('.drawer.is-open, .facets.is-open').forEach((x) => x.classList.remove('is-open'));
      overlay()?.classList.remove('is-active');
      document.body.classList.remove('no-scroll');
    },
  };
  window.Drawer = Drawer;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const id = opener.dataset.drawerOpen;
      if (id === 'CartDrawer' && window.theme.cartType === 'page') return;
      e.preventDefault();
      Drawer.open(id);
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) {
      e.preventDefault();
      Drawer.close();
    }
    const facetsOpen = e.target.closest('[data-facets-open]');
    if (facetsOpen) {
      $('.facets')?.classList.add('is-open');
      overlay()?.classList.add('is-active');
    }
  });
  document.addEventListener('keydown', (e) => e.key === 'Escape' && Drawer.close());

  /* ---------- Toast ---------- */
  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove('is-visible'), 2800);
  }

  /* ---------- Cart ---------- */
  const Cart = {
    sections: ['cart-drawer-content', 'cart-count'],
    async refresh(sectionsHtml) {
      let data = sectionsHtml;
      if (!data) {
        const res = await fetch(`${window.theme.routes.root}?sections=${this.sections.join(',')}`);
        data = await res.json();
      }
      const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
      if (data['cart-drawer-content']) {
        const doc = parse(data['cart-drawer-content']);
        const fresh = doc.querySelector('[data-cart-drawer-inner]');
        const cur = $('[data-cart-drawer-inner]');
        if (fresh && cur) cur.replaceWith(fresh);
      }
      if (data['cart-count']) {
        const doc = parse(data['cart-count']);
        const count = doc.querySelector('[data-cart-count-src]')?.textContent.trim() || '0';
        const total = doc.querySelector('[data-cart-total-src]')?.innerHTML || '';
        $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === '0' && el.dataset.hideEmpty !== undefined; });
        $$('[data-cart-total]').forEach((el) => (el.innerHTML = total));
      }
    },
    async add(formData) {
      formData.append('sections', this.sections.join(','));
      formData.append('sections_url', window.location.pathname);
      const res = await fetch(`${window.theme.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
      const json = await res.json();
      if (json.status) throw new Error(json.description || json.message);
      await this.refresh(json.sections);
      return json;
    },
    async change(line, quantity) {
      const res = await fetch(`${window.theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: this.sections, sections_url: window.location.pathname }),
      });
      const json = await res.json();
      if (json.status) { toast(json.description || json.message); await this.refresh(); return; }
      await this.refresh(json.sections);
      if (document.body.classList.contains('template-cart')) window.location.reload();
    },
  };
  window.Cart = Cart;

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || window.theme.cartType === 'page') return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    btn?.classList.add('loading');
    btn?.setAttribute('aria-disabled', 'true');
    try {
      await Cart.add(new FormData(form));
      Drawer.open('CartDrawer');
    } catch (err) {
      toast(err.message);
    } finally {
      btn?.classList.remove('loading');
      btn?.removeAttribute('aria-disabled');
    }
  });

  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); Cart.change(+rm.dataset.line, 0); return; }
    const wl = e.target.closest('[data-wishlist]');
    if (wl) {
      const key = 'lux-wishlist';
      let list = [];
      try { list = JSON.parse(localStorage.getItem(key)) || []; } catch (err) {}
      const h = wl.dataset.wishlist;
      list = list.includes(h) ? list.filter((x) => x !== h) : list.concat(h);
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (err) {}
      document.querySelectorAll('[data-wishlist="' + h + '"]').forEach((b) => b.setAttribute('aria-pressed', list.includes(h)));
      return;
    }
    const sh = e.target.closest('[data-share]');
    if (sh) {
      const url = sh.dataset.share;
      if (navigator.share) { navigator.share({ title: sh.dataset.shareTitle, url }).catch(() => {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(url).then(() => { sh.classList.add('is-copied'); setTimeout(() => sh.classList.remove('is-copied'), 1500); }); }
      return;
    }
    const q = e.target.closest('[data-qty-btn]');
    if (q) {
      const wrap = q.closest('.qty');
      const input = wrap.querySelector('input');
      const step = q.dataset.qtyBtn === 'plus' ? 1 : -1;
      const min = +input.min || 0;
      input.value = Math.max(min, (+input.value || 0) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  let qtyTimer;
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-line-qty]');
    if (!input) return;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(() => Cart.change(+input.dataset.line, +input.value), 350);
  });
  document.addEventListener('change', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(`${window.theme.routes.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* ---------- Slider ---------- */
  class SliderComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');
      this.dots = $$('[data-slider-dot]', this);
      this.prev?.addEventListener('click', () => this.go(-1));
      this.next?.addEventListener('click', () => this.go(1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.goTo(i)));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.update();
      const autoplay = +this.dataset.autoplay;
      if (autoplay) {
        this.timer = setInterval(() => { if (!this.matches(':hover')) this.go(1, true); }, autoplay * 1000);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
    items() { return Array.from(this.track.children); }
    step() {
      const it = this.items();
      if (it.length < 2) return this.track.clientWidth;
      return it[1].offsetLeft - it[0].offsetLeft;
    }
    index() { return Math.round(this.track.scrollLeft / this.step()); }
    go(dir, loop) {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (loop && dir > 0 && this.track.scrollLeft >= max) { this.track.scrollTo({ left: 0 }); return; }
      this.track.scrollBy({ left: dir * this.step() * (this.dataset.page ? Math.max(1, Math.floor(this.track.clientWidth / this.step())) : 1) });
    }
    goTo(i) {
      const it = this.items()[i];
      if (it) this.track.scrollTo({ left: it.offsetLeft - this.items()[0].offsetLeft });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      const i = this.index();
      this.dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
    }
  }
  customElements.define('slider-component', SliderComponent);

  /* Peek slideshow (centered slides) */
  class PeekSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.peek__track');
      this.dots = $$('[data-slider-dot]', this);
      const slides = () => Array.from(this.track.children);
      const center = (el) => this.track.scrollTo({ left: el.offsetLeft - (this.track.clientWidth - el.clientWidth) / 2 });
      this.dots.forEach((d, i) => d.addEventListener('click', () => center(slides()[i])));
      const update = () => {
        const mid = this.track.scrollLeft + this.track.clientWidth / 2;
        let best = 0, dist = Infinity;
        slides().forEach((s, i) => { const d = Math.abs(s.offsetLeft + s.clientWidth / 2 - mid); if (d < dist) { dist = d; best = i; } });
        this.current = best;
        this.dots.forEach((d, i) => d.setAttribute('aria-current', i === best ? 'true' : 'false'));
      };
      this.track.addEventListener('scroll', update, { passive: true });
      update();
      const autoplay = +this.dataset.autoplay;
      if (autoplay) setInterval(() => { if (this.matches(':hover')) return; const s = slides(); center(s[(this.current + 1) % s.length]); }, autoplay * 1000);
    }
  }
  customElements.define('peek-slider', PeekSlider);

  /* ---------- Countdown ---------- */
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const end = new Date(this.dataset.end.replace(' ', 'T')).getTime();
      if (isNaN(end)) return;
      const f = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const d = Math.floor(s / 86400); s %= 86400;
        const h = Math.floor(s / 3600); s %= 3600;
        const m = Math.floor(s / 60); s %= 60;
        const set = (k, v) => $$(`[data-${k}]`, this).forEach((el) => (el.textContent = v));
        set('days', d); set('hours', f(h)); set('mins', f(m)); set('secs', f(s));
        if (end <= Date.now() && this.dataset.hideExpired !== undefined) this.hidden = true;
      };
      tick();
      this.t = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.t); }
  }
  customElements.define('countdown-timer', CountdownTimer);

  /* ---------- Tabs ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[role=tab]');
    if (!tab) return;
    const list = tab.closest('[role=tablist]');
    const root = tab.closest('[data-tabs]');
    $$('[role=tab]', list).forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
    $$('[role=tabpanel]', root).forEach((p) => (p.hidden = p.id !== tab.getAttribute('aria-controls')));
  });

  /* ---------- Product form / variant picker ---------- */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-product-json]');
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.form = this.querySelector('form[data-product-form]');
      this.addEventListener('change', (e) => { if (e.target.closest('[data-option-input]')) this.onChange(); });
      this.gallery = document.querySelector(`[data-gallery="${this.dataset.section}"]`);
      this.updateAvailability();
    }
    selected() {
      return $$('[data-option-group]', this).map((g) => g.querySelector('input:checked')?.value);
    }
    onChange() {
      const opts = this.selected();
      const v = this.product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      this.variant = v;
      $$('[data-option-group]', this).forEach((g, i) => { const l = g.querySelector('[data-selected-value]'); if (l) l.textContent = opts[i]; });
      this.updateAvailability();
      const btn = this.querySelector('[data-add-button]');
      const btnText = this.querySelector('[data-add-text]');
      const idInput = this.querySelector('input[name=id]');
      if (!v) {
        btn && (btn.disabled = true);
        btnText && (btnText.textContent = window.theme.strings.unavailable);
        return;
      }
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      btn && (btn.disabled = !v.available);
      btnText && (btnText.textContent = v.available ? window.theme.strings.addToCart : window.theme.strings.soldOut);
      if (this.dataset.updateUrl !== 'false') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
      this.renderPrice(v);
      const sku = this.querySelector('[data-sku]');
      if (sku) sku.textContent = v.sku || '—';
      if (v.featured_media && this.gallery) this.gallery.dispatchEvent(new CustomEvent('gallery:goto', { detail: v.featured_media.id }));
      const sticky = document.querySelector('[data-sticky-atc-price]');
      if (sticky) sticky.innerHTML = this.formatMoney(v.price);
    }
    updateAvailability() {
      const groups = $$('[data-option-group]', this);
      const sel = this.selected();
      groups.forEach((g, gi) => {
        $$('input', g).forEach((input) => {
          const test = sel.slice(); test[gi] = input.value;
          const ok = this.product.variants.some((v) => v.available && v.options.every((o, i) => i === gi ? o === input.value : (i < gi ? o === test[i] : true)));
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    formatMoney(cents) {
      const fmt = this.dataset.moneyFormat || '₹{{amount}}';
      const amount = (cents / 100).toFixed(2);
      const [int, dec] = amount.split('.');
      const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
        if (k === 'amount_no_decimals') return withCommas;
        if (k === 'amount_with_comma_separator') return `${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`;
        if (k === 'amount_no_decimals_with_comma_separator') return int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `${withCommas}.${dec}`;
      });
    }
    renderPrice(v) {
      const p = this.querySelector('[data-price]');
      if (!p) return;
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      p.innerHTML = onSale
        ? `<span class="price__sale">${this.formatMoney(v.price)}</span><s class="price__compare">${this.formatMoney(v.compare_at_price)}</s>`
        : `<span>${this.formatMoney(v.price)}</span>`;
    }
  }
  customElements.define('product-info', ProductInfo);

  /* ---------- Gallery ---------- */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelector('.gallery__slides');
      this.thumbs = $$('[data-thumb]', this);
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.goIndex(i)));
      const count = () => $$('.gallery__slide', this.slides).length;
      const cur = () => Math.round(this.slides.scrollLeft / this.slides.clientWidth);
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.goIndex((cur() - 1 + count()) % count()));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.goIndex((cur() + 1) % count()));
      this.slides?.addEventListener('scroll', () => {
        const i = Math.round(this.slides.scrollLeft / this.slides.clientWidth);
        this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      }, { passive: true });
      this.addEventListener('gallery:goto', (e) => {
        const i = $$('[data-media-id]', this.slides).findIndex((s) => s.dataset.mediaId == e.detail);
        if (i > -1) this.goIndex(i);
      });
    }
    goIndex(i) {
      this.slides.scrollTo({ left: this.slides.clientWidth * i });
      this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      this.thumbs[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }
  customElements.define('product-gallery', ProductGallery);

  /* ---------- Sticky add to cart ---------- */
  const stickyAtc = $('[data-sticky-atc]');
  const mainAtc = $('[data-main-atc]');
  if (stickyAtc && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => stickyAtc.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(mainAtc);
    stickyAtc.querySelector('button')?.addEventListener('click', () => mainAtc.closest('form')?.requestSubmit());
  }

  /* ---------- Predictive search ---------- */
  $$('[data-predictive-input]').forEach((input) => {
    const results = document.getElementById(input.dataset.predictiveInput);
    if (!results) return;
    let t, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = results.dataset.default || ''; return; }
      if (results.dataset.default === undefined) results.dataset.default = results.innerHTML;
      t = setTimeout(async () => {
        ctrl?.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[limit]=8`, { signal: ctrl.signal });
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          results.innerHTML = doc.querySelector('[data-predictive-results]')?.innerHTML || '';
        } catch (_) {}
      }, 250);
    });
  });

  /* ---------- Collection filters (auto submit) ---------- */
  document.addEventListener('change', (e) => {
    const form = e.target.closest('form[data-auto-submit]');
    if (!form) return;
    if (e.target.type === 'number') return;
    form.requestSubmit ? form.requestSubmit() : form.submit();
  });
  $$('[data-sort-select]').forEach((sel) => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));

  /* ---------- Localization selects ---------- */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('.localization-form select');
    if (sel) sel.form.submit();
  });

  /* ---------- Header search -> open drawer on mobile ---------- */
  window.addEventListener('pageshow', () => Drawer.close());
})();

document.addEventListener('DOMContentLoaded', () => {
  let list = [];
  try { list = JSON.parse(localStorage.getItem('lux-wishlist')) || []; } catch (err) {}
  document.querySelectorAll('[data-wishlist]').forEach((b) => b.setAttribute('aria-pressed', list.includes(b.dataset.wishlist)));
});
